<template>
<div class="grid">

<template v-if="loading">

<div class="col-12 md:col-6">

<div class="grid">

<div class="col-12">
<Skeleton  height="2.2rem" class="mb-5 mt-3"></Skeleton>
<Skeleton height="2rem" class="mb-3 mt-3"></Skeleton>
<Skeleton height="2rem" class="mb-3"></Skeleton>
<Skeleton height="2rem" class="mb-3"></Skeleton>
<Skeleton height="2rem" class="mb-2"></Skeleton>
</div>
</div>
</div>
<div class="col-12 md:col-6">
<Skeleton  height="18rem" class="mt-3"></Skeleton>
</div>
<!-- line chart --> 

</template>





<template v-if="!loading">
<div class="col-12 md:col-6">

<div class="grid">

<div class="col-12">

<template v-if="inputfield.translations.length">
    <h3 class="text-purple-500 mb-0" v-for="translation in inputfield.translations" v-show="translation.language_id == $store.state.auth.user.preflang_id">{{translation.translation}}</h3>
</template>
<template v-else>
   <h3 class="text-purple-500 mb-0" >{{inputfield.name}}</h3> 
</template>
</div>

<div class="col-12">
<div class="grid" v-for="option in inputfield.options">


  <div class="col-10"><h4 class="text-primary mb-0" >{{getTheTranslation(option,'translation')}}  </h4></div>  





<div class="col-2"><Tag class="ml-2 mt-4" :value="$filters.numberformat( option.submission_count)" aria-label="Tabable Primary Tag" tabindex="0"></Tag></div>
</div>




</div>

</div>

</div>


<!--  suppliers -->

<!-- line chart -->	
<div class="col-12 md:col-6">
<Chart type="bar" :data="barData" :options="barOptions" ref="thechart"/>
</div>
</template>


</div>
</template>


<script>
export default {
  props:["inputfield"],
  name: 'BarChart',

  data () {
    return {
    	loading:true,
    	barData: {
            labels: [],
            datasets: [
                {
                    label: this.$store.state.languages.lang_phrases.isaretleme_sayisi,
                    backgroundColor: '#7e2f8d',
                    data: []
                },
            ]
        },
       	barOptions: {
            plugins: {
                legend: {
                	
                }
            },
            scales: {
                x: {
                    ticks: {
                        color: '#495057'
                    },
                    grid: {
                        color: '#ebedef'
                    }
                },
                y: {
                    min:0,
                    ticks: {
                        color: '#495057'
                    },
                    grid: {
                        color: '#ebedef'
                    }
                }
            }
        },
    }
  },
  mounted()
  {

  },
  methods:{
  	async changeBarData(data,labels)
  	{
        console.log("changeBarData")
        console.log(data)
        console.log(labels)
  		this.loading = await true
  		this.barData.datasets[0].data = await data
  		this.barData.labels = await labels
  		this.loading = await false   
  	}
  },
}
</script>

<style lang="css" scoped>
</style>